







































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Field } from "vant";
@Component({
  name: "trainCard",
  components: {
    [Field.name]: Field,
  },
})
export default class TrainCard extends Vue {
  changeStatus = "pick";
  changePickUp(key: string) {
    let __self = this;
    __self.changeStatus = key;
  }
}
